// dependencies
import Immutable from "immutable";
import Cookies from "js-cookie";
import lodash from "lodash";
import moment from "moment";

import pdfToImages from "../../utils/pdfToImages";

// conditionally import libraries to the global scope
// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === "production") {
	window.moment = moment;
	window.pdfToImages = pdfToImages;
	window.Cookies = Cookies;
} else {
	window.Cookies = Cookies;
	window.lodash = lodash;
	window.moment = moment;
	window.Immutable = Immutable;
	window.pdfToImages = pdfToImages;
}
